import React from "react";
import styled from "styled-components";
import Image from "gatsby-image";
import { StaticQuery, graphql } from "gatsby";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/styles";
import { usePageContext } from "components/PageContext";

import GoldWhiteBanner from "../../assets/images/gold-white-banner.svg";
import { Hidden } from "@material-ui/core";

const TrapezoidBadge = styled(Box)`
  background-image: url(${GoldWhiteBanner});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: right;
  text-decoration: none;
`;

const useStyles = makeStyles({
  uppercase: {
    textTransform: "uppercase"
  }
});

export default () => {
  // const { jumpkickImage } = props;
  const classes = useStyles();
  const context = usePageContext();
  const {
    page: { full_slug }
  } = context;
  const slug = full_slug?.match(/standort(\/.*\/)/)[1];

  // console.log("Ban", context);

  return (
    <StaticQuery
      query={graphql`
        {
          jumpkick: file(name: { eq: "jumpkick" }) {
            id
            name
            childImageSharp {
              fluid(maxWidth: 440) {
                ...GatsbyImageSharpFluid
              }
            }
          }
        }
      `}
      render={props => {
        return (
          <Box
            bgcolor="tertiary.main"
            width="100%"
            display="flex"
            alignItems="stretch"
            m="3.8rem 0"
            px={{ xs: "4.165vw", md: "8.33vw" }}
          >
            <Box color="text.secondary" flex={2}>
              <Box
                fontSize={{ xs: "2.2rem", sm: "4.2rem", md: "4.5rem" }}
                fontWeight={700}
                my={{ xs: "0", sm: "-0.8rem" }}
                className={classes.uppercase}
              >
                Probetraining
              </Box>
              <Box
                fontSize={{ xs: "1rem", sm: "1.2rem" }}
                fontWeight={700}
                className={classes.uppercase}
              >
                An allen Standorten täglich Einsteigerkurse!
              </Box>
              <Box
                fontSize={{ xs: "0.9rem", sm: "1.1rem" }}
                fontWeight={400}
                mb="0.8rem"
              >
                Speziell für Erwachsene / Kinder & Senioren!
              </Box>
              <TrapezoidBadge
                component="a"
                // href="#kontakt"
                href={`${slug}#kontakt`}
                display="block"
                color="text.primary"
                p="12px 72px 12px 24px"
                width="max-content"
                zIndex={9999}
              >
                <Box
                  fontSize="1.33rem" // 3.5?1.8
                  fontWeight={700}
                  className={classes.uppercase}
                >
                  Termin Vereinbaren
                </Box>
              </TrapezoidBadge>
            </Box>

            <Hidden smDown>
              <Box flex={1} position="relative">
                <Box
                  position="absolute"
                  top="-25%"
                  bottom="-25%"
                  left="0"
                  right="0"
                >
                  <Image
                    fluid={props.jumpkick.childImageSharp.fluid}
                    style={{ height: "100%" }}
                    imgStyle={{
                      objectFit: "scale-down",
                      objectPosition: "right center"
                    }}
                  />
                </Box>
              </Box>
            </Hidden>
          </Box>
        );
      }}
    />
  );
};
